<div class="subBlockContent" id="confirmUpgrade">
  <child-header [title]="title" (closeEvent)="close()"></child-header>
  <loading-screen *ngIf="!loadContent" backDropWidth="640" [isScrolled]="true" [showBlurTable]="false"
    (currentLoadingStatus)="onLoading($event)">
  </loading-screen>

  <div #ParentWrapper class="inner-subBlock-wrapper child-body" style="margin: 20px 0px 0px 20px;">
    <form [formGroup]="form">
      <div class="pannel-outter-wrapper">
        <table class="table">
          <thead hidden="true">
            <tr>
              <th scope="col" class="align-left" style="width: 30%;">Stock Code</th>
              <th scope="col" class="align-left" style="width: 30%;">Title</th>
              <!-- <th scope="col" class="align-center" style="width: 20%;">Quantity</th> -->
            </tr>
          </thead>
          <tbody>

            <!-- from subscription-->
            <div class="my-2">
              <span class="highlight-text">FROM:</span>
            </div>
            <mat-spinner *ngIf="!from" mode="indeterminate" class="circle" style="margin-left: 40px;" diameter="20">
            </mat-spinner>
            <tr *ngIf="from">
              <td style="width: 30%;">
                <span class="description-popup">{{from?.out_stock_code}}</span>
              </td>
              <td style="width: 30%;">
                <span class="description-popup">{{from?.out_stk_description}}</span>
              </td>
              <!-- <td class="align-center" style="position: relative;vertical-align: middle; width:20%">
                <span>{{from.out_confirmed_qty}}</span>
              </td> -->
            </tr>

            <div class="my-2">
              <span class="highlight-text">TO:</span>
            </div>

            <mat-spinner *ngIf="!isRenewLoaded" mode="indeterminate" class="circle" style="margin-left: 40px;" diameter="20">
            </mat-spinner>
            <tr *ngIf="isRenewLoaded">
              <td style="width: 30%;">
                <span class="description-popup">{{  (renewal.value ? this.renewal.value : this.termDuration) + ':' + (to?.catalogItemId | cspTransitionSkuPipe) }}</span>
              </td>
              <td style="width: 30%;">
                <span class="description-popup">{{to?.title}}</span>
              </td>
              <!-- <td class="align-center" style="position: relative;vertical-align: middle; width:20%">
                <span>{{to.quantity}}</span>
              </td> -->
            </tr>
          </tbody>
        </table>

        <!-- Existing subscriptions select-->
        <div class="my-4" *ngIf="existingSubList?.length">
          <div class="my-2">
            <span>DESTINATION SUBSCRIPTION</span>
          </div>
          <div class="row">
            <div class="col-6">
              <mat-form-field appearance="fill" style="padding-left: 0px;">
                <mat-select  formControlName="toSubscription" class="destination-sub">
                  <mat-option [value]="0">New Subscription</mat-option>
                  <mat-option 
                    *ngFor="let sub of existingSubList"
                    [value]="sub?.baseSubscription?.out_subscription_id"
                  >
                    {{ sub?.baseSubscription?.out_sub_description }}({{ sub?.baseSubscription?.out_subscription_id }}) Qty:{{ sub?.baseSubscription?.out_confirmed_qty }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- QUANTITY-->
        <div class="my-4">

          <div>
            <span> <span class="highlight-text">QUANTITY: </span> CURRENT : {{from?.out_confirmed_qty}}</span>
          </div>


          <div class="my-2">
            <span>QUANTITY TO UPGRADE:</span>
          </div>

          <!---->
          <div class="row my-2">
            <div class="col-6">
              <input type="number" aria-label="Number" formControlName="toQty" [disabled]="toQty &&  !isRenewLoaded" integerOnly> <span
                class="ml-2">Licenses</span>
            </div>
            
            <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
              *ngIf="qtyLoading">
            </mat-spinner>
          </div>
          <span class="text-danger" *ngIf="(toQty.dirty || toQty.touched) && toQty.errors?.zeroError"> *Qty must be greater than 0</span>
          <!-- <span class="text-danger" *ngIf="(toQty.dirty || toQty.touched) && toQty.errors?.confirmQtyError"> *Qty must be greater than current qty:{{from?.out_confirmed_qty}}</span> -->

        </div>

        <!-- TERM DURATION-->
        <div class="my-4">

          <div>
            <span> <span class="highlight-text">TERM :</span> Current :
              {{ termDuration =='P1M'?'Monthly':'Annual'}}</span>
          </div>

          <div class="my-2">
            <span>CHANGE TO:</span>
          </div>

          <div class="row">
            <div class="col-6">
              <mat-form-field appearance="fill" style="padding-left: 0px;">
                <!-- <mat-label>{{getTermDuration(from)=='P1M'?'Monthly':'Annual'}}</mat-label> -->
                <mat-select formControlName="renewal"
                  [attr.disabled]="isSubInProgress(from) || !isRenewLoaded || !autoRenewalEnabled">
                  <mat-option value="">
                    No Change</mat-option>
                  <mat-option *ngIf="getMCEUpgradeModel.termDuration !== 'P1M'" value="P1M">
                    Monthly</mat-option>
                  <mat-option *ngIf="getMCEUpgradeModel.termDuration !== 'P1Y'" value="P1Y">
                    Annual</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
              style="position: relative;top:15px" *ngIf="renewalLoading">
            </mat-spinner>
          </div>
        </div>

        <!-- Billing Freqency-->
        <div class="my-4">

          <div>
            <span> <span class="highlight-text">BILLING FREQUENCY : </span> Current :
              {{billingCycle !== 'monthly'?'Annual':'Monthly'}}</span>
          </div>

          <div class="my-2">
            <span>CHANGE TO:</span>
          </div>

          <div class="row">
            <div class="col-6">
              <mat-form-field appearance="fill" style="padding-left: 0px;">
                <!-- <mat-label>{{from.out_billing_freq == 'Y'?'Annual':'Monthly'}}</mat-label> -->
                <mat-select formControlName="billing"
                  [attr.disabled]="isSubInProgress(from) || !isRenewLoaded || !autoRenewalEnabled">
                  <mat-option value="">
                    No Change</mat-option>
                  <ng-container *ngIf="getMCEUpgradeModel.billingCycle !== 'monthly'">
                    <ng-container *ngIf="getMCEUpgradeModel.billingCycle !== 'monthly';else monthly">
                      <mat-option value="P1M">Monthly</mat-option>
                    </ng-container>
                    <ng-template #monthly>
                      <mat-option value="P1Y">Annual</mat-option>
                    </ng-template>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
              style="position: relative;top:15px" *ngIf="billingLoading">
            </mat-spinner>
          </div>
        </div>

        <!-- End Date Alignment -->
        <div class="my-4">

          <div>
            <span> <span class="highlight-text">END DATE ALIGNMENT : </span> Current :
              {{ from?.out_expiry_date | date: 'dd/MM/yyyy' }}</span>
          </div>

          <div class="my-2">
            <span>CHANGE TO:</span>
          </div>

          <div class="row">
            <div class="col-6">
              <ng-container>
                <mat-form-field appearance="fill" style="padding-left: 0px;">
                  <mat-select
                    formControlName="customEndDateTypeControl"
                    class="customDropdwon"
                    bindValue="value"
                    bindLabel="displayText"
                    (selectionChange)="changeEndDate($event.value, tempRef)"
                    [disableControl]="
                      isSubInProgress(from) ||
                      !from?.out_activeSuspend
                    "
                  >
                    <mat-option *ngFor="let type of customEndDateTypeList" [value]="type" >
                      {{ type }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="custom-end-date" *ngIf="this.form.get('customEndDateTypeControl')?.value !== 'No Change'">
                  <div class="searchIcon">
                    <img src="../images/new_ui/date.png">
                  </div>
                  <input #customEndAateInput class="custom-end-date-input" type="text" placeholder="Date" mame="shippingDate" ngbDatepicker
                    #dA="ngbDatepicker" formControlName="customEndDate" (click)="openRightPanel(tempRef)"
                    readonly>
                  <mat-icon
                    matSuffix class="editmpnidicon"
                    placement="bottom"
                    matTooltip="You can co-term your new NCE subscription to the same end date as any other non-trial NCE subscription already present on the tenant or align to calendar month."
                  >
                    info
                  </mat-icon>
                  
                  <!-- ViewSubEndDate hover -->
                  <span class="produc-secondary-title-wrapper" *ngIf="form.get('customEndDateTypeControl')?.value == 'Co-Term'">
                    <a
                      style="cursor: pointer;"
                      placement="bottom"
                      (click)="openRightPanel(tempRef)"
                    >
                      <span class="small-logo-wrapper">
                        <img style="width: 16px; height: 16px;" src="../images/new_ui/clock-red.svg">
                      </span>
                      View subscription end-dates
                    </a>
                  </span>
                  <!-- view end dates right panel -->

                </div>
              </ng-container>
              <!-- For Software -->
           <!--  <ng-container *ngIf="isSoftwareOrRI">
                <mat-form-field appearance="fill" style="padding-left: 0px;">
               
                  <mat-select formControlName="billing"
                    [disableControl]="isSubInProgress() || !isRenewLoaded || !upgradeSubscriptionForm.get('autoRenewalEnabled').value">
                    <mat-option value="">
                      No Change</mat-option>
                      <ng-container *ngFor="let bcy of supportedBillingCycles">
                        <mat-option  *ngIf="billingCycle !== bcy" value="{{bcy}}">{{bcy | titlecase}}</mat-option>
                      </ng-container>
                  </mat-select>
                </mat-form-field>
              </ng-container> -->
            </div>
            <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
              style="position: relative;top:15px" *ngIf="billingLoading">
            </mat-spinner>
          </div>
        </div>

        <div style="margin-top: 10px;" class="text-center">
          <button class="button button-red button-mid confirmbutton" [disabled]="!isRenewLoaded" (click)="postTransition()">Confirm</button>
        </div>
      </div>
    </form>
    <!-- view end dates right panel -->
    <ng-template #tempRef>
      <div id="sidecontainer">
        <child-header title="View subscription end-dates" (closeEvent)="sidenavService.panel.close()"></child-header>
        <div class="child-body">
          <p class="ml-3 view-end-date-title">This end date alignment must match with either one of the below subscriptions expiry date</p>
          <ng-container *ngFor="let s of subsForViewEndDates">
            <div style="font-size: 11px; margin-left: 30px; cursor: pointer;" (click)="assignEndDate(s.baseSubscription.out_expiry_date)">
              <span>Expiry Date: <span class="exp-date">{{ s.baseSubscription?.out_expiry_date }}</span></span><br />
              <span>{{ s.baseSubscription?.out_sub_description }}</span><br />
              <span>{{ s.baseSubscription?.out_stk_description }}</span><br />
              <span>SKU: {{ s.baseSubscription?.out_stock_code }}</span><br />
            </div>
            <br />
          </ng-container>
        </div>
      </div>
    </ng-template>  
  </div>
</div>
